import { Component, OnInit, ChangeDetectionStrategy, inject } from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {ActionButtonComponent} from "../../Components/action-button/action-button.component";
import {GreenActionButtonComponent} from "../../Components/green-action-button/green-action-button.component";
import {AuthService} from "../../Services/auth.service";

@Component({
    selector: 'no-child-but-school-page',
    templateUrl: './NoChildButSchoolPage.component.html',
    styleUrls: ['./NoChildButSchoolPage.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ActionButtonComponent, GreenActionButtonComponent]
})
export class NoChildButSchoolPageComponent implements OnInit {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private auth = inject(AuthService);


  restoId: number = 0;


  ngOnInit(): void {
    if(!this.auth.userSubject.value){
      this.router.navigate(["/"]);
      return;
    }

    this.activatedRoute.params.subscribe(params => {
      const restoIdString: string = params["id"] || "0";
      this.restoId = parseInt(restoIdString);
    })
  }

  switchAccount(){
    this.auth.logout();
    this.returnToIndex();
  }

  returnToIndex(){
    this.router.navigate(['/']);
  }
}
